import createIcon from '../../createIcon';

/**
 * @component @name ContactSupport
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM3LjMxIDIgMy41IDUuODEgMy41IDEwLjVDMy41IDE1LjE5IDcuMzEgMTkgMTIgMTlIMTIuNVYyMkMxNy4zNiAxOS42NiAyMC41IDE1IDIwLjUgMTAuNUMyMC41IDUuODEgMTYuNjkgMiAxMiAyWk0xMyAxNi41SDExVjE0LjVIMTNWMTYuNVpNMTMgMTNIMTFDMTEgOS43NSAxNCAxMCAxNCA4QzE0IDYuOSAxMy4xIDYgMTIgNkMxMC45IDYgMTAgNi45IDEwIDhIOEM4IDUuNzkgOS43OSA0IDEyIDRDMTQuMjEgNCAxNiA1Ljc5IDE2IDhDMTYgMTAuNSAxMyAxMC43NSAxMyAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContactSupport = createIcon('ContactSupport', [
  [
    'path',
    {
      d: 'M12 2C7.31 2 3.5 5.81 3.5 10.5C3.5 15.19 7.31 19 12 19H12.5V22C17.36 19.66 20.5 15 20.5 10.5C20.5 5.81 16.69 2 12 2ZM13 16.5H11V14.5H13V16.5ZM13 13H11C11 9.75 14 10 14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8H8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8C16 10.5 13 10.75 13 13Z',
      key: 'v27cup',
    },
  ],
]);

export default ContactSupport;
